<script setup lang="ts">
const {
  size = "md",
  link,
  color = "light",
} = defineProps<{
  size?: "sm" | "md";
  color?: "dark" | "light";
  link: {
    url?: string;
    slug?: string;
    title: string;
    [key: string]: any; // allow any other properties from contentful
  };
}>();

const to = computed(
  () =>
    link?.slug ||
    link?.url ||
    link.link?.fields?.slug ||
    link.link?.fields?.url,
);
</script>

<template>
  <NuxtLink
    exact-active-class="footer-link--active"
    active-class="footer-link--active"
    :class="[
      'footer-link',
      { 'footer-link--sm': size === 'sm' },
      `footer-link--${color}`,
    ]"
    :to
  >
    {{ link.title }}
  </NuxtLink>
</template>

<style scoped lang="scss">
.footer-link {
  display: inline-block;
  text-decoration: none;
  color: var(--primary-white, #ffffff);
  font-family: var(--font-family, sans-serif);
  line-height: 1.5rem;
  font-size: 1rem;

  &--sm {
    font-size: 0.75rem;
    text-decoration: underline;
  }

  &--dark {
    color: var(--primary-black, #000000);
  }

  &:hover {
    color: var(--primary-red, #ff0038);
  }
}
</style>
